import {
  TIKTOK_INDUSTRY_22102000000,
  TIKTOK_INDUSTRY_22101000000,
  TIKTOK_INDUSTRY_22107000000,
  TIKTOK_INDUSTRY_22108000000,
  TIKTOK_INDUSTRY_22109000000,
  TIKTOK_INDUSTRY_22106000000,
  TIKTOK_INDUSTRY_22999000000,
  TIKTOK_INDUSTRY_22112000000,
  TIKTOK_INDUSTRY_22105000000,
  TIKTOK_INDUSTRY_22113000000,
  TIKTOK_INDUSTRY_22110000000,
  TIKTOK_INDUSTRY_22111000000,
  TIKTOK_INDUSTRY_16105000000,
  TIKTOK_INDUSTRY_16104000000,
  TIKTOK_INDUSTRY_16101000000,
  TIKTOK_INDUSTRY_16102000000,
  TIKTOK_INDUSTRY_16999000000,
  TIKTOK_INDUSTRY_16100000000,
  TIKTOK_INDUSTRY_20101000000,
  TIKTOK_INDUSTRY_20110000000,
  TIKTOK_INDUSTRY_20104000000,
  TIKTOK_INDUSTRY_20106000000,
  TIKTOK_INDUSTRY_20109000000,
  TIKTOK_INDUSTRY_20107000000,
  TIKTOK_INDUSTRY_20102000000,
  TIKTOK_INDUSTRY_20105000000,
  TIKTOK_INDUSTRY_20999000000,
  TIKTOK_INDUSTRY_20111000000,
  TIKTOK_INDUSTRY_20103000000,
  TIKTOK_INDUSTRY_20100000000,
  TIKTOK_INDUSTRY_20108000000,
  TIKTOK_INDUSTRY_20112000000,
  TIKTOK_INDUSTRY_12104000000,
  TIKTOK_INDUSTRY_12108000000,
  TIKTOK_INDUSTRY_12100000000,
  TIKTOK_INDUSTRY_12102000000,
  TIKTOK_INDUSTRY_12110000000,
  TIKTOK_INDUSTRY_12105000000,
  TIKTOK_INDUSTRY_12107000000,
  TIKTOK_INDUSTRY_12109000000,
  TIKTOK_INDUSTRY_12103000000,
  TIKTOK_INDUSTRY_12999000000,
  TIKTOK_INDUSTRY_12101000000,
  TIKTOK_INDUSTRY_12106000000,
  TIKTOK_INDUSTRY_14105000000,
  TIKTOK_INDUSTRY_14104000000,
  TIKTOK_INDUSTRY_14107000000,
  TIKTOK_INDUSTRY_14106000000,
  TIKTOK_INDUSTRY_14101000000,
  TIKTOK_INDUSTRY_14100000000,
  TIKTOK_INDUSTRY_14999000000,
  TIKTOK_INDUSTRY_14103000000,
  TIKTOK_INDUSTRY_14102000000,
  TIKTOK_INDUSTRY_24118000000,
  TIKTOK_INDUSTRY_24105000000,
  TIKTOK_INDUSTRY_24103000000,
  TIKTOK_INDUSTRY_24104000000,
  TIKTOK_INDUSTRY_24109000000,
  TIKTOK_INDUSTRY_24114000000,
  TIKTOK_INDUSTRY_24107000000,
  TIKTOK_INDUSTRY_24120000000,
  TIKTOK_INDUSTRY_24119000000,
  TIKTOK_INDUSTRY_24116000000,
  TIKTOK_INDUSTRY_24117000000,
  TIKTOK_INDUSTRY_24111000000,
  TIKTOK_INDUSTRY_24106000000,
  TIKTOK_INDUSTRY_24112000000,
  TIKTOK_INDUSTRY_24101000000,
  TIKTOK_INDUSTRY_24999000000,
  TIKTOK_INDUSTRY_24113000000,
  TIKTOK_INDUSTRY_24100000000,
  TIKTOK_INDUSTRY_24102000000,
  TIKTOK_INDUSTRY_24110000000,
  TIKTOK_INDUSTRY_24115000000,
  TIKTOK_INDUSTRY_30100000000,
  TIKTOK_INDUSTRY_30102000000,
  TIKTOK_INDUSTRY_30101000000,
  TIKTOK_INDUSTRY_10100000000,
  TIKTOK_INDUSTRY_10102000000,
  TIKTOK_INDUSTRY_10105000000,
  TIKTOK_INDUSTRY_10106000000,
  TIKTOK_INDUSTRY_10999000000,
  TIKTOK_INDUSTRY_10103000000,
  TIKTOK_INDUSTRY_10101000000,
  TIKTOK_INDUSTRY_10104000000,
  TIKTOK_INDUSTRY_13100000000,
  TIKTOK_INDUSTRY_13108000000,
  TIKTOK_INDUSTRY_13117000000,
  TIKTOK_INDUSTRY_13115000000,
  TIKTOK_INDUSTRY_13116000000,
  TIKTOK_INDUSTRY_13112000000,
  TIKTOK_INDUSTRY_13107000000,
  TIKTOK_INDUSTRY_13104000000,
  TIKTOK_INDUSTRY_13102000000,
  TIKTOK_INDUSTRY_13110000000,
  TIKTOK_INDUSTRY_13111000000,
  TIKTOK_INDUSTRY_13109000000,
  TIKTOK_INDUSTRY_13999000000,
  TIKTOK_INDUSTRY_13105000000,
  TIKTOK_INDUSTRY_13113000000,
  TIKTOK_INDUSTRY_13101000000,
  TIKTOK_INDUSTRY_13114000000,
  TIKTOK_INDUSTRY_1310300000,
  TIKTOK_INDUSTRY_27103000000,
  TIKTOK_INDUSTRY_27104000000,
  TIKTOK_INDUSTRY_27100000000,
  TIKTOK_INDUSTRY_27101000000,
  TIKTOK_INDUSTRY_27102000000,
  TIKTOK_INDUSTRY_27999000000,
  TIKTOK_INDUSTRY_25301000000,
  TIKTOK_INDUSTRY_25302000000,
  TIKTOK_INDUSTRY_25300000000,
  TIKTOK_INDUSTRY_25313000000,
  TIKTOK_INDUSTRY_25303000000,
  TIKTOK_INDUSTRY_25999000000,
  TIKTOK_INDUSTRY_25311000000,
  TIKTOK_INDUSTRY_25304000000,
  TIKTOK_INDUSTRY_25305000000,
  TIKTOK_INDUSTRY_25306000000,
  TIKTOK_INDUSTRY_25307000000,
  TIKTOK_INDUSTRY_25308000000,
  TIKTOK_INDUSTRY_25309000000,
  TIKTOK_INDUSTRY_25310000000,
  TIKTOK_INDUSTRY_25312000000,
  TIKTOK_INDUSTRY_29102000000,
  TIKTOK_INDUSTRY_29101000000,
  TIKTOK_INDUSTRY_29100000000,
  TIKTOK_INDUSTRY_29103000000,
  TIKTOK_INDUSTRY_29999000000,
  TIKTOK_INDUSTRY_21102000000,
  TIKTOK_INDUSTRY_21101000000,
  TIKTOK_INDUSTRY_21103000000,
  TIKTOK_INDUSTRY_21104000000,
  TIKTOK_INDUSTRY_21100000000,
  TIKTOK_INDUSTRY_21999000000,
  TIKTOK_INDUSTRY_21105000000,
  TIKTOK_INDUSTRY_18106000000,
  TIKTOK_INDUSTRY_18110000000,
  TIKTOK_INDUSTRY_18104000000,
  TIKTOK_INDUSTRY_18101000000,
  TIKTOK_INDUSTRY_18102000000,
  TIKTOK_INDUSTRY_18105000000,
  TIKTOK_INDUSTRY_18108000000,
  TIKTOK_INDUSTRY_18109000000,
  TIKTOK_INDUSTRY_18999000000,
  TIKTOK_INDUSTRY_18112000000,
  TIKTOK_INDUSTRY_18100000000,
  TIKTOK_INDUSTRY_18103000000,
  TIKTOK_INDUSTRY_18107000000,
  TIKTOK_INDUSTRY_18111000000,
  TIKTOK_INDUSTRY_26114000000,
  TIKTOK_INDUSTRY_26112000000,
  TIKTOK_INDUSTRY_26102000000,
  TIKTOK_INDUSTRY_26113000000,
  TIKTOK_INDUSTRY_26108000000,
  TIKTOK_INDUSTRY_26104000000,
  TIKTOK_INDUSTRY_26105000000,
  TIKTOK_INDUSTRY_26111000000,
  TIKTOK_INDUSTRY_26999000000,
  TIKTOK_INDUSTRY_26101000000,
  TIKTOK_INDUSTRY_26106000000,
  TIKTOK_INDUSTRY_26107000000,
  TIKTOK_INDUSTRY_26109000000,
  TIKTOK_INDUSTRY_26103000000,
  TIKTOK_INDUSTRY_26100000000,
  TIKTOK_INDUSTRY_23113000000,
  TIKTOK_INDUSTRY_23114000000,
  TIKTOK_INDUSTRY_23122000000,
  TIKTOK_INDUSTRY_23102000000,
  TIKTOK_INDUSTRY_23126000000,
  TIKTOK_INDUSTRY_23108000000,
  TIKTOK_INDUSTRY_23105000000,
  TIKTOK_INDUSTRY_23111000000,
  TIKTOK_INDUSTRY_23116000000,
  TIKTOK_INDUSTRY_23104000000,
  TIKTOK_INDUSTRY_23128000000,
  TIKTOK_INDUSTRY_23107000000,
  TIKTOK_INDUSTRY_23124000000,
  TIKTOK_INDUSTRY_23125000000,
  TIKTOK_INDUSTRY_23127000000,
  TIKTOK_INDUSTRY_23115000000,
  TIKTOK_INDUSTRY_23106000000,
  TIKTOK_INDUSTRY_23109000000,
  TIKTOK_INDUSTRY_23110000000,
  TIKTOK_INDUSTRY_23100000000,
  TIKTOK_INDUSTRY_23119000000,
  TIKTOK_INDUSTRY_23999000000,
  TIKTOK_INDUSTRY_23129000000,
  TIKTOK_INDUSTRY_23101000000,
  TIKTOK_INDUSTRY_23118000000,
  TIKTOK_INDUSTRY_23130000000,
  TIKTOK_INDUSTRY_23131000000,
  TIKTOK_INDUSTRY_23103000000,
  TIKTOK_INDUSTRY_23134000000,
  TIKTOK_INDUSTRY_23123000000,
  TIKTOK_INDUSTRY_23132000000,
  TIKTOK_INDUSTRY_23133000000,
  TIKTOK_INDUSTRY_23112000000,
  TIKTOK_INDUSTRY_23117000000,
  TIKTOK_INDUSTRY_19999000000,
  TIKTOK_INDUSTRY_19103000000,
  TIKTOK_INDUSTRY_19101000000,
  TIKTOK_INDUSTRY_19102000000,
  TIKTOK_INDUSTRY_19105000000,
  TIKTOK_INDUSTRY_19106000000,
  TIKTOK_INDUSTRY_19104000000,
  TIKTOK_INDUSTRY_19100000000,
  TIKTOK_INDUSTRY_28100000000,
  TIKTOK_INDUSTRY_28101000000,
  TIKTOK_INDUSTRY_15100000000,
  TIKTOK_INDUSTRY_15105000000,
  TIKTOK_INDUSTRY_15103000000,
  TIKTOK_INDUSTRY_15101000000,
  TIKTOK_INDUSTRY_15102000000,
  TIKTOK_INDUSTRY_15104000000,
  TIKTOK_INDUSTRY_15106000000,
  TIKTOK_INDUSTRY_15107000000,
  TIKTOK_INDUSTRY_15999000000,
  TIKTOK_INDUSTRY_17103000000,
  TIKTOK_INDUSTRY_17999000000,
  TIKTOK_INDUSTRY_17105000000,
  TIKTOK_INDUSTRY_17106000000,
  TIKTOK_INDUSTRY_11111000000,
  TIKTOK_INDUSTRY_11110000000,
  TIKTOK_INDUSTRY_11101000000,
  TIKTOK_INDUSTRY_11103000000,
  TIKTOK_INDUSTRY_11102000000,
  TIKTOK_INDUSTRY_11100000000,
  TIKTOK_INDUSTRY_11107000000,
  TIKTOK_INDUSTRY_11112000000,
  TIKTOK_INDUSTRY_11104000000,
  TIKTOK_INDUSTRY_11108000000,
  TIKTOK_INDUSTRY_11106000000,
  TIKTOK_INDUSTRY_11999000000,
  TIKTOK_INDUSTRY_11105000000,
  TIKTOK_INDUSTRY_11109000000,
} from "../i18n/keysTranslations";

// TikTok Business industries (customer_info.industry in bc/advertiser/create).
// Source: TikTok Ads industry codes (community mirror of the official Appendix - Industries).
// If TikTok rejects an ID, update it here (single source of truth for the UI).
export const TIKTOK_BUSINESS_INDUSTRIES = [
  { value: "22102000000", label: TIKTOK_INDUSTRY_22102000000 },
  {
    value: "22101000000",
    label: TIKTOK_INDUSTRY_22101000000,
  },
  { value: "22107000000", label: TIKTOK_INDUSTRY_22107000000 },
  { value: "22108000000", label: TIKTOK_INDUSTRY_22108000000 },
  { value: "22109000000", label: TIKTOK_INDUSTRY_22109000000 },
  { value: "22106000000", label: TIKTOK_INDUSTRY_22106000000 },
  {
    value: "22999000000",
    label: TIKTOK_INDUSTRY_22999000000,
  },
  {
    value: "22112000000",
    label: TIKTOK_INDUSTRY_22112000000,
  },
  { value: "22105000000", label: TIKTOK_INDUSTRY_22105000000 },
  {
    value: "22113000000",
    label: TIKTOK_INDUSTRY_22113000000,
  },
  { value: "22110000000", label: TIKTOK_INDUSTRY_22110000000 },
  { value: "22111000000", label: TIKTOK_INDUSTRY_22111000000 },
  { value: "16105000000", label: TIKTOK_INDUSTRY_16105000000 },
  { value: "16104000000", label: TIKTOK_INDUSTRY_16104000000 },
  { value: "16101000000", label: TIKTOK_INDUSTRY_16101000000 },
  { value: "16102000000", label: TIKTOK_INDUSTRY_16102000000 },
  { value: "16999000000", label: TIKTOK_INDUSTRY_16999000000 },
  { value: "16100000000", label: TIKTOK_INDUSTRY_16100000000 },
  { value: "20101000000", label: TIKTOK_INDUSTRY_20101000000 },
  { value: "20110000000", label: TIKTOK_INDUSTRY_20110000000 },
  { value: "20104000000", label: TIKTOK_INDUSTRY_20104000000 },
  { value: "20106000000", label: TIKTOK_INDUSTRY_20106000000 },
  { value: "20109000000", label: TIKTOK_INDUSTRY_20109000000 },
  { value: "20107000000", label: TIKTOK_INDUSTRY_20107000000 },
  { value: "20102000000", label: TIKTOK_INDUSTRY_20102000000 },
  { value: "20105000000", label: TIKTOK_INDUSTRY_20105000000 },
  { value: "20999000000", label: TIKTOK_INDUSTRY_20999000000 },
  { value: "20111000000", label: TIKTOK_INDUSTRY_20111000000 },
  { value: "20103000000", label: TIKTOK_INDUSTRY_20103000000 },
  { value: "20100000000", label: TIKTOK_INDUSTRY_20100000000 },
  { value: "20108000000", label: TIKTOK_INDUSTRY_20108000000 },
  { value: "20112000000", label: TIKTOK_INDUSTRY_20112000000 },
  { value: "12104000000", label: TIKTOK_INDUSTRY_12104000000 },
  {
    value: "12108000000",
    label: TIKTOK_INDUSTRY_12108000000,
  },
  { value: "12100000000", label: TIKTOK_INDUSTRY_12100000000 },
  { value: "12102000000", label: TIKTOK_INDUSTRY_12102000000 },
  {
    value: "12110000000",
    label: TIKTOK_INDUSTRY_12110000000,
  },
  { value: "12105000000", label: TIKTOK_INDUSTRY_12105000000 },
  { value: "12107000000", label: TIKTOK_INDUSTRY_12107000000 },
  {
    value: "12109000000",
    label: TIKTOK_INDUSTRY_12109000000,
  },
  {
    value: "12103000000",
    label: TIKTOK_INDUSTRY_12103000000,
  },
  {
    value: "12999000000",
    label: TIKTOK_INDUSTRY_12999000000,
  },
  { value: "12101000000", label: TIKTOK_INDUSTRY_12101000000 },
  { value: "12106000000", label: TIKTOK_INDUSTRY_12106000000 },
  {
    value: "14105000000",
    label: TIKTOK_INDUSTRY_14105000000,
  },
  { value: "14104000000", label: TIKTOK_INDUSTRY_14104000000 },
  { value: "14107000000", label: TIKTOK_INDUSTRY_14107000000 },
  {
    value: "14106000000",
    label: TIKTOK_INDUSTRY_14106000000,
  },
  { value: "14101000000", label: TIKTOK_INDUSTRY_14101000000 },
  { value: "14100000000", label: TIKTOK_INDUSTRY_14100000000 },
  {
    value: "14999000000",
    label: TIKTOK_INDUSTRY_14999000000,
  },
  { value: "14103000000", label: TIKTOK_INDUSTRY_14103000000 },
  {
    value: "14102000000",
    label: TIKTOK_INDUSTRY_14102000000,
  },
  {
    value: "24108000000",
    label:
      "Business Services / Agriculture, Forestry, Animal Husbandry & Fishing",
  },
  { value: "24118000000", label: TIKTOK_INDUSTRY_24118000000 },
  { value: "24105000000", label: TIKTOK_INDUSTRY_24105000000 },
  {
    value: "24103000000",
    label: TIKTOK_INDUSTRY_24103000000,
  },
  {
    value: "24104000000",
    label: TIKTOK_INDUSTRY_24104000000,
  },
  {
    value: "24109000000",
    label: TIKTOK_INDUSTRY_24109000000,
  },
  { value: "24114000000", label: TIKTOK_INDUSTRY_24114000000 },
  { value: "24107000000", label: TIKTOK_INDUSTRY_24107000000 },
  {
    value: "24120000000",
    label: TIKTOK_INDUSTRY_24120000000,
  },
  {
    value: "24119000000",
    label: TIKTOK_INDUSTRY_24119000000,
  },
  { value: "24116000000", label: TIKTOK_INDUSTRY_24116000000 },
  { value: "24117000000", label: TIKTOK_INDUSTRY_24117000000 },
  { value: "24111000000", label: TIKTOK_INDUSTRY_24111000000 },
  { value: "24106000000", label: TIKTOK_INDUSTRY_24106000000 },
  {
    value: "24112000000",
    label: TIKTOK_INDUSTRY_24112000000,
  },
  {
    value: "24101000000",
    label: TIKTOK_INDUSTRY_24101000000,
  },
  {
    value: "24999000000",
    label: TIKTOK_INDUSTRY_24999000000,
  },
  {
    value: "24113000000",
    label: TIKTOK_INDUSTRY_24113000000,
  },
  {
    value: "24100000000",
    label: TIKTOK_INDUSTRY_24100000000,
  },
  {
    value: "24102000000",
    label: TIKTOK_INDUSTRY_24102000000,
  },
  { value: "24110000000", label: TIKTOK_INDUSTRY_24110000000 },
  { value: "24115000000", label: TIKTOK_INDUSTRY_24115000000 },
  { value: "30100000000", label: TIKTOK_INDUSTRY_30100000000 },
  {
    value: "30102000000",
    label: TIKTOK_INDUSTRY_30102000000,
  },
  {
    value: "30101000000",
    label: TIKTOK_INDUSTRY_30101000000,
  },
  {
    value: "10100000000",
    label: TIKTOK_INDUSTRY_10100000000,
  },
  { value: "10102000000", label: TIKTOK_INDUSTRY_10102000000 },
  { value: "10105000000", label: TIKTOK_INDUSTRY_10105000000 },
  {
    value: "10106000000",
    label: TIKTOK_INDUSTRY_10106000000,
  },
  { value: "10999000000", label: TIKTOK_INDUSTRY_10999000000 },
  { value: "10103000000", label: TIKTOK_INDUSTRY_10103000000 },
  {
    value: "10101000000",
    label: TIKTOK_INDUSTRY_10101000000,
  },
  { value: "10104000000", label: TIKTOK_INDUSTRY_10104000000 },
  { value: "13100000000", label: TIKTOK_INDUSTRY_13100000000 },
  { value: "13108000000", label: TIKTOK_INDUSTRY_13108000000 },
  { value: "13117000000", label: TIKTOK_INDUSTRY_13117000000 },
  { value: "13115000000", label: TIKTOK_INDUSTRY_13115000000 },
  { value: "13116000000", label: TIKTOK_INDUSTRY_13116000000 },
  {
    value: "13112000000",
    label: TIKTOK_INDUSTRY_13112000000,
  },
  { value: "13107000000", label: TIKTOK_INDUSTRY_13107000000 },
  { value: "13104000000", label: TIKTOK_INDUSTRY_13104000000 },
  { value: "13102000000", label: TIKTOK_INDUSTRY_13102000000 },
  { value: "13110000000", label: TIKTOK_INDUSTRY_13110000000 },
  { value: "13111000000", label: TIKTOK_INDUSTRY_13111000000 },
  {
    value: "13109000000",
    label: TIKTOK_INDUSTRY_13109000000,
  },
  {
    value: "13999000000",
    label: TIKTOK_INDUSTRY_13999000000,
  },
  { value: "13105000000", label: TIKTOK_INDUSTRY_13105000000 },
  { value: "13113000000", label: TIKTOK_INDUSTRY_13113000000 },
  { value: "13101000000", label: TIKTOK_INDUSTRY_13101000000 },
  { value: "13114000000", label: TIKTOK_INDUSTRY_13114000000 },
  { value: "1310300000", label: TIKTOK_INDUSTRY_1310300000 },
  { value: "27103000000", label: TIKTOK_INDUSTRY_27103000000 },
  { value: "27104000000", label: TIKTOK_INDUSTRY_27104000000 },
  { value: "27100000000", label: TIKTOK_INDUSTRY_27100000000 },
  { value: "27101000000", label: TIKTOK_INDUSTRY_27101000000 },
  { value: "27102000000", label: TIKTOK_INDUSTRY_27102000000 },
  { value: "27999000000", label: TIKTOK_INDUSTRY_27999000000 },
  { value: "25301000000", label: TIKTOK_INDUSTRY_25301000000 },
  { value: "25302000000", label: TIKTOK_INDUSTRY_25302000000 },
  { value: "25300000000", label: TIKTOK_INDUSTRY_25300000000 },
  { value: "25313000000", label: TIKTOK_INDUSTRY_25313000000 },
  { value: "25303000000", label: TIKTOK_INDUSTRY_25303000000 },
  { value: "25999000000", label: TIKTOK_INDUSTRY_25999000000 },
  { value: "25311000000", label: TIKTOK_INDUSTRY_25311000000 },
  { value: "25304000000", label: TIKTOK_INDUSTRY_25304000000 },
  { value: "25305000000", label: TIKTOK_INDUSTRY_25305000000 },
  { value: "25306000000", label: TIKTOK_INDUSTRY_25306000000 },
  { value: "25307000000", label: TIKTOK_INDUSTRY_25307000000 },
  { value: "25308000000", label: TIKTOK_INDUSTRY_25308000000 },
  { value: "25309000000", label: TIKTOK_INDUSTRY_25309000000 },
  { value: "25310000000", label: TIKTOK_INDUSTRY_25310000000 },
  { value: "25312000000", label: TIKTOK_INDUSTRY_25312000000 },
  { value: "29102000000", label: TIKTOK_INDUSTRY_29102000000 },
  { value: "29101000000", label: TIKTOK_INDUSTRY_29101000000 },
  { value: "29100000000", label: TIKTOK_INDUSTRY_29100000000 },
  { value: "29103000000", label: TIKTOK_INDUSTRY_29103000000 },
  { value: "29999000000", label: TIKTOK_INDUSTRY_29999000000 },
  {
    value: "21102000000",
    label: TIKTOK_INDUSTRY_21102000000,
  },
  { value: "21101000000", label: TIKTOK_INDUSTRY_21101000000 },
  { value: "21103000000", label: TIKTOK_INDUSTRY_21103000000 },
  { value: "21104000000", label: TIKTOK_INDUSTRY_21104000000 },
  {
    value: "21100000000",
    label: TIKTOK_INDUSTRY_21100000000,
  },
  { value: "21999000000", label: TIKTOK_INDUSTRY_21999000000 },
  { value: "21105000000", label: TIKTOK_INDUSTRY_21105000000 },
  { value: "18106000000", label: TIKTOK_INDUSTRY_18106000000 },
  { value: "18110000000", label: TIKTOK_INDUSTRY_18110000000 },
  { value: "18104000000", label: TIKTOK_INDUSTRY_18104000000 },
  { value: "18101000000", label: TIKTOK_INDUSTRY_18101000000 },
  { value: "18102000000", label: TIKTOK_INDUSTRY_18102000000 },
  { value: "18105000000", label: TIKTOK_INDUSTRY_18105000000 },
  { value: "18108000000", label: TIKTOK_INDUSTRY_18108000000 },
  { value: "18109000000", label: TIKTOK_INDUSTRY_18109000000 },
  {
    value: "18999000000",
    label: TIKTOK_INDUSTRY_18999000000,
  },
  { value: "18112000000", label: TIKTOK_INDUSTRY_18112000000 },
  { value: "18100000000", label: TIKTOK_INDUSTRY_18100000000 },
  { value: "18103000000", label: TIKTOK_INDUSTRY_18103000000 },
  { value: "18107000000", label: TIKTOK_INDUSTRY_18107000000 },
  { value: "18111000000", label: TIKTOK_INDUSTRY_18111000000 },
  { value: "26114000000", label: TIKTOK_INDUSTRY_26114000000 },
  { value: "26112000000", label: TIKTOK_INDUSTRY_26112000000 },
  {
    value: "26102000000",
    label: TIKTOK_INDUSTRY_26102000000,
  },
  { value: "26113000000", label: TIKTOK_INDUSTRY_26113000000 },
  { value: "26108000000", label: TIKTOK_INDUSTRY_26108000000 },
  { value: "26104000000", label: TIKTOK_INDUSTRY_26104000000 },
  { value: "26105000000", label: TIKTOK_INDUSTRY_26105000000 },
  { value: "26111000000", label: TIKTOK_INDUSTRY_26111000000 },
  { value: "26999000000", label: TIKTOK_INDUSTRY_26999000000 },
  { value: "26101000000", label: TIKTOK_INDUSTRY_26101000000 },
  { value: "26106000000", label: TIKTOK_INDUSTRY_26106000000 },
  { value: "26107000000", label: TIKTOK_INDUSTRY_26107000000 },
  { value: "26109000000", label: TIKTOK_INDUSTRY_26109000000 },
  { value: "26103000000", label: TIKTOK_INDUSTRY_26103000000 },
  { value: "26100000000", label: TIKTOK_INDUSTRY_26100000000 },
  { value: "23113000000", label: TIKTOK_INDUSTRY_23113000000 },
  { value: "23114000000", label: TIKTOK_INDUSTRY_23114000000 },
  {
    value: "23122000000",
    label: TIKTOK_INDUSTRY_23122000000,
  },
  { value: "23102000000", label: TIKTOK_INDUSTRY_23102000000 },
  { value: "23126000000", label: TIKTOK_INDUSTRY_23126000000 },
  {
    value: "23108000000",
    label: TIKTOK_INDUSTRY_23108000000,
  },
  {
    value: "23105000000",
    label: TIKTOK_INDUSTRY_23105000000,
  },
  {
    value: "23111000000",
    label: TIKTOK_INDUSTRY_23111000000,
  },
  { value: "23116000000", label: TIKTOK_INDUSTRY_23116000000 },
  { value: "23104000000", label: TIKTOK_INDUSTRY_23104000000 },
  {
    value: "23128000000",
    label: TIKTOK_INDUSTRY_23128000000,
  },
  {
    value: "23107000000",
    label: TIKTOK_INDUSTRY_23107000000,
  },
  { value: "23124000000", label: TIKTOK_INDUSTRY_23124000000 },
  {
    value: "23125000000",
    label: TIKTOK_INDUSTRY_23125000000,
  },
  { value: "23127000000", label: TIKTOK_INDUSTRY_23127000000 },
  { value: "23115000000", label: TIKTOK_INDUSTRY_23115000000 },
  { value: "23106000000", label: TIKTOK_INDUSTRY_23106000000 },
  { value: "23109000000", label: TIKTOK_INDUSTRY_23109000000 },
  { value: "23110000000", label: TIKTOK_INDUSTRY_23110000000 },
  { value: "23100000000", label: TIKTOK_INDUSTRY_23100000000 },
  { value: "23119000000", label: TIKTOK_INDUSTRY_23119000000 },
  {
    value: "23999000000",
    label: TIKTOK_INDUSTRY_23999000000,
  },
  { value: "23129000000", label: TIKTOK_INDUSTRY_23129000000 },
  { value: "23101000000", label: TIKTOK_INDUSTRY_23101000000 },
  { value: "23118000000", label: TIKTOK_INDUSTRY_23118000000 },
  {
    value: "23130000000",
    label: TIKTOK_INDUSTRY_23130000000,
  },
  {
    value: "23131000000",
    label: TIKTOK_INDUSTRY_23131000000,
  },
  {
    value: "23103000000",
    label: TIKTOK_INDUSTRY_23103000000,
  },
  {
    value: "23134000000",
    label: TIKTOK_INDUSTRY_23134000000,
  },
  { value: "23123000000", label: TIKTOK_INDUSTRY_23123000000 },
  { value: "23132000000", label: TIKTOK_INDUSTRY_23132000000 },
  { value: "23133000000", label: TIKTOK_INDUSTRY_23133000000 },
  { value: "23112000000", label: TIKTOK_INDUSTRY_23112000000 },
  { value: "23117000000", label: TIKTOK_INDUSTRY_23117000000 },
  { value: "19999000000", label: TIKTOK_INDUSTRY_19999000000 },
  { value: "19103000000", label: TIKTOK_INDUSTRY_19103000000 },
  { value: "19101000000", label: TIKTOK_INDUSTRY_19101000000 },
  { value: "19102000000", label: TIKTOK_INDUSTRY_19102000000 },
  { value: "19105000000", label: TIKTOK_INDUSTRY_19105000000 },
  { value: "19106000000", label: TIKTOK_INDUSTRY_19106000000 },
  { value: "19104000000", label: TIKTOK_INDUSTRY_19104000000 },
  { value: "19100000000", label: TIKTOK_INDUSTRY_19100000000 },
  { value: "28100000000", label: TIKTOK_INDUSTRY_28100000000 },
  { value: "28101000000", label: TIKTOK_INDUSTRY_28101000000 },
  { value: "15100000000", label: TIKTOK_INDUSTRY_15100000000 },
  { value: "15105000000", label: TIKTOK_INDUSTRY_15105000000 },
  { value: "15103000000", label: TIKTOK_INDUSTRY_15103000000 },
  { value: "15101000000", label: TIKTOK_INDUSTRY_15101000000 },
  { value: "15102000000", label: TIKTOK_INDUSTRY_15102000000 },
  { value: "15104000000", label: TIKTOK_INDUSTRY_15104000000 },
  { value: "15106000000", label: TIKTOK_INDUSTRY_15106000000 },
  { value: "15107000000", label: TIKTOK_INDUSTRY_15107000000 },
  {
    value: "15999000000",
    label: TIKTOK_INDUSTRY_15999000000,
  },
  { value: "17103000000", label: TIKTOK_INDUSTRY_17103000000 },
  { value: "17999000000", label: TIKTOK_INDUSTRY_17999000000 },
  { value: "17105000000", label: TIKTOK_INDUSTRY_17105000000 },
  { value: "17106000000", label: TIKTOK_INDUSTRY_17106000000 },
  {
    value: "11111000000",
    label: TIKTOK_INDUSTRY_11111000000,
  },
  { value: "11110000000", label: TIKTOK_INDUSTRY_11110000000 },
  {
    value: "11101000000",
    label: TIKTOK_INDUSTRY_11101000000,
  },
  { value: "11103000000", label: TIKTOK_INDUSTRY_11103000000 },
  { value: "11102000000", label: TIKTOK_INDUSTRY_11102000000 },
  { value: "11100000000", label: TIKTOK_INDUSTRY_11100000000 },
  { value: "11107000000", label: TIKTOK_INDUSTRY_11107000000 },
  { value: "11112000000", label: TIKTOK_INDUSTRY_11112000000 },
  { value: "11104000000", label: TIKTOK_INDUSTRY_11104000000 },
  {
    value: "11108000000",
    label: TIKTOK_INDUSTRY_11108000000,
  },
  { value: "11106000000", label: TIKTOK_INDUSTRY_11106000000 },
  {
    value: "11999000000",
    label: TIKTOK_INDUSTRY_11999000000,
  },
  { value: "11105000000", label: TIKTOK_INDUSTRY_11105000000 },
  { value: "11109000000", label: TIKTOK_INDUSTRY_11109000000 },
];
